import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.less']
})
export class ErrorModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
